export class FarmsDapRepository {
  constructor(api) {
    this.api = api
  }
  async create(farm_rows, ID_FARM) {
    let values = ``;


    farm_rows.forEach((row, index, rows) => {
      let {
        DAP,
        STRESS,
        KC,
        BRANCH,
        DEPTH_ROOT,
        AVAILABILITY,
      } = row;
      values += `
      (${DAP},
      ${STRESS},
      ${KC},
      ${BRANCH},
      ${DEPTH_ROOT},
      ${AVAILABILITY},
      ${ID_FARM})${index === rows.length - 1 ? "" : ","}`;
    });
    const raw = `
      INSERT INTO CROP.FARMS_DAP (
        DAP,
        STRESS,
        KC,
        BRANCH,
        DEPTH_ROOT,
        AVAILABILITY,
        ID_FARM
      )VALUES${values};
    `;
    return  await this.api.sql({
      data: {
        sql: raw
      }
    })
  }
  async showFarmsByIdFarmUseCase(ID_FARM) {
    const raw = `
    SELECT fd.ID ,fd.DAP ,IF(fd.STRESS=1,true,false) AS STRESS ,fd.KC ,fd.BRANCH ,fd.DEPTH_ROOT ,fd.AVAILABILITY FROM CROP.FARMS_DAP fd
    WHERE ID_FARM = ${ID_FARM};
  `
    return await this.api.sql({
      data: {
        sql: raw
      }
    })

  }
  async getOrderedFarmDapById(ID_FARM){
    const raw = `
      SELECT * FROM CROP.FARMS_DAP
      WHERE ID_FARM = ${ID_FARM}
      ORDER BY DAP ASC;
    `
    const resp= await this.api.sql({
      data: {
        sql: raw
      }
    })
    return resp[0]
  }
  async getLastRecordByIdFarm(ID_FARM){
    const raw = `
      SELECT * FROM CROP.FARMS_DAP
      WHERE ID_FARM = ${ID_FARM}
      ORDER BY DAP DESC
      LIMIT 1;
    `
    const resp= await this.api.sql({
      data: {
        sql: raw
      }
    })
    return resp && resp[0] && resp[0].length ? resp[0][0] : null
  }
  async getByIdFarmAndDAP(ID_FARM,DAP){
    const raw = `
      SELECT * FROM CROP.FARMS_DAP
      WHERE ID_FARM = ${ID_FARM}
      AND DAP = ${DAP}
      LIMIT 1;
    `
    const resp= await this.api.sql({
      data: {
        sql: raw
      }
    })
    return resp && resp[0] && resp[0].length ? resp[0][0] : null
  }
  async deleteFarmsByIdFarmUseCase(ID_FARM) {
    const raw = `
      DELETE  FROM  CROP.FARMS_DAP
      WHERE ID_FARM = ${ID_FARM};
    `
    return await this.api.sql({
      data: {
        sql: raw
      }
    })

  }

  async checkFarmsWithData(ids){
    const raw = `
      SELECT
        ID
      FROM CROP.FARM
      WHERE ID IN (
        SELECT ID_FARM
        FROM CROP.FARMS_DAP FD
      ) AND ID IN (${ids.join(",")});
  `
    const resp= await this.api.sql({
      data: {
        sql: raw
      }
    })
    
    return resp && resp[0] && resp[0].map(val => val.ID);
  }

  async checkIfExistsFarmDap(ID_FARM){
    const raw = `
    SELECT EXISTS (SELECT * FROM CROP.FARMS_DAP
    WHERE ID_FARM = ${ID_FARM} LIMIT 1) AS isExists;
  `
    const resp= await this.api.sql({
      data: {
        sql: raw
      }
    })

    if (resp[0].length) {
      let result = resp[0][0]
      return 'isExists' in result ? result.isExists : 0;
    }
    return;
  }

}
